import React from 'react';
import styled from 'styled-components';

import { Col, Separator, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import COLORS from 'constants/colors';

const Column = styled(Col)`
  margin-bottom: 32px;
`;

const Title = styled(Text)`
  text-transform: capitalize;
`;

const ReferralIncentives = ({ incentives }) => {
  return (
    <>
      {Object.entries(incentives)?.map(([key, value]) => {
        return (
          <Column key={key}>
            <Title variant="cta2">{key}</Title>
            <Separator height={18} transparent />
            {value?.map(el => {
              const { incentive_name, reward_description } = el || {};
              return (
                <>
                  <Row style={{ gap: '16px' }}>
                    <Text style={{ flex: 1 }} variant="eyebrow2" color={COLORS.BLACK_75}>
                      Incentive
                    </Text>
                    <Text style={{ flex: 1 }} variant="body1" weight="bold">
                      {incentive_name}
                    </Text>
                  </Row>
                  <Separator height={18} transparent />
                  <Row style={{ gap: '16px' }}>
                    <Text style={{ flex: 1 }} variant="eyebrow2" color={COLORS.BLACK_75}>
                      Reward description
                    </Text>
                    <Text style={{ flex: 1 }} variant="body1" weight="bold">
                      {reward_description}
                    </Text>
                  </Row>
                </>
              );
            })}
          </Column>
        );
      })}
    </>
  );
};

export default ReferralIncentives;
